import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { NavTabsList } from '../NavTabsList/NavTabsList.js';
import { NavTabsTab } from '../NavTabsTab/NavTabsTab.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "isSelected", "navTabs", "render"],
    _excluded2 = ["children", "href"];
var defaultElement = "a";
var NavTabs = /*#__PURE__*/React.forwardRef(function NavTabs2(props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? defaultElement : _props$as,
      isSelected = props.isSelected,
      navTabs = props.navTabs,
      render = props.render,
      tabListProps = _objectWithoutProperties(props, _excluded);

  if (render) {
    if (process.env.NODE_ENV !== "production") {
      console.error("NavTabs error: The `render` prop is deprecated. Please, use the polymorphic `as` prop instead.");
    }
  }

  return /*#__PURE__*/jsx(NavTabsList, _objectSpread(_objectSpread({}, tabListProps), {}, {
    ref: ref,
    children: navTabs.map(function (navTab, i) {
      navTab.children;
          navTab.href;
          var rest = _objectWithoutProperties(navTab, _excluded2);

      var rendered = render ? render(navTab) : void 0;
      var nextProps = rendered ? _objectSpread(_objectSpread(_objectSpread({}, rest), rendered.props), {}, {
        href: rendered.props.href,
        children: rendered.props.label || rendered.props.children
      }) : navTab;
      return /*#__PURE__*/jsx(NavTabsTab, _objectSpread(_objectSpread({
        "aria-current": isSelected(navTab) ? "page" : void 0
      }, nextProps), {}, {
        as: as
      }), i);
    })
  }));
});
NavTabs.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "isSelected": _PropTypes.func.isRequired,
  "navTabs": _PropTypes.arrayOf(_PropTypes.object).isRequired,
  "render": _PropTypes.func
};
NavTabs.displayName = "NavTabs";

export { NavTabs };
